import { db } from "../config/firebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import { getOrSetCache, invalidateCache } from "../utils/cacheUtil";

const STUDENT_ATTENDANCE_CACHE_TTL_MS = 2 * 60 * 1000;

class AttendanceService {
  async getAttendanceByDate(date, options = {}) {
    const { forceRefresh = false } = options;
    const cacheKey = `students:attendance:${date}`;

    if (forceRefresh) {
      invalidateCache(cacheKey);
    }

    return getOrSetCache(
      cacheKey,
      async () => {
        try {
          const studentsSnapshot = await getDocs(collection(db, "students"));

          const presentStudents = [];
          const absentStudents = [];

          const validStudents = studentsSnapshot.docs.filter((d) => {
            const name = d.data().name;
            return name && !name.toLowerCase().includes("student");
          });

          const totalStudents = validStudents.length;

          const promises = validStudents.map(async (studentDoc) => {
            const student = studentDoc.data();
            const attendanceRef = collection(
              db,
              "students",
              studentDoc.id,
              "attendance",
            );
            const attendanceDocs = await getDocs(attendanceRef);

            let presentFullDay = false;

            attendanceDocs.forEach((att) => {
              const data = att.data();
              if (data[date]?.attendedFullDay === true) {
                presentFullDay = true;
              }
            });

            const model = {
              name: student.name,
              className: student.className,
              uid: student.uid,
            };

            if (presentFullDay) presentStudents.push(model);
            else absentStudents.push(model);
          });

          await Promise.all(promises);

          return {
            presentStudents,
            absentStudents,
            presentCount: presentStudents.length,
            absentCount: absentStudents.length,
            totalStudents,
          };
        } catch (error) {
          console.error("Attendance fetch error", error);
          throw error;
        }
      },
      STUDENT_ATTENDANCE_CACHE_TTL_MS,
    );
  }
}

const attendanceService = new AttendanceService();

export default attendanceService;
